import React from "react";
import img from "../../assets/img/invis-landing-what.webp";

const Invisalign = () => {
  return (
    <section>
      <div
        className="container-fluid"
        style={{
          height: "60vh",
          backgroundImage: `url(${img})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}>
        {" "}
      </div>
      <div className="container">
        <div
          className="row justify-content-center align-items-center"
          style={{ marginTop: "-9.375rem" }}>
          <div className="col-12 col-md-12">
            <div className="card rounded-0 border-0 bg-light bg-white py-lg-5 px-lg-5 px-3 py-5">
              <h2 className="card-title mb-4 fs-40">What is Invisalign®?</h2>
              <div className="row align-items-start">
                <div className="col-12 col-md-6">
                  <p className="card-text fs-15 px-lg-3 lh-lg">
                    Invisalign® is the revolution in teeth straightening using
                    clear aligners which are worn for a minimum of 22 hours per
                    day. You can remove the aligners to eat, have hot drinks and
                    to brush your teeth. You wear each aligner for around one
                    week and your dedicated compliance is essential for the
                    system to work.
                  </p>
                </div>

                <div className="col-12 col-md-6">
                  <p className="card-text fs-16 px-lg-3 lh-lg">
                    Invisalign® works with a series of personalised laboratory
                    manufactured aligners, designed to uniquely move your teeth
                    slightly closer to your final smile. As your teeth move, you
                    move onto the next set of aligners until you’ve achieved
                    your perfect smile.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Invisalign;
